import React from 'react';
import { ProgressBar } from 'react-bootstrap';

const LinearProgressBar = ({ percentage, isExpanded, isFinished }) => {
  return (
    <ProgressBar
      className={isExpanded ? 'progress-bar-expanded' : 'progress-bar-collapsed' }
      now={percentage}
      bsClass={`progress-bar${isFinished ? ' progress-bar-finished' : ''}`}
    />
  )
}

export default LinearProgressBar;


// WEBPACK FOOTER //
// ./src/components/status-progress-bar.js